module.exports = __webpack_public_path__ + "img/bg-sec-2.9ee3d8c3.png";